const tableStyle = {
    headerStyle:{background: '#F5F6F8','font-weight':600,color:'#606266','text-align':'center'},
    headerStyleC:{background: '#f2f4c7','font-weight':600,color:'#606266','text-align':'center'},
    rowStyle:{background: '#f2f4c785'},
    cellStyle:{}
}

export default tableStyle;